import { useEffect, useLayoutEffect, useMemo, useState } from 'react'
import { STATUS } from '@/v1/constants/status'
import { useGetCountries } from '@/api/api-hooks'
import { getLocalStorage } from '@/v1/lib/local-storage'
import LocalStorageKeys from '@/configs/caching/keys/local-storage'

export const useCountries = () => {
  const { mutateAsync, isPending } = useGetCountries()
  const [countries, setCountries] = useState([])

  // Retrieve cached countries from local storage
  const cachedCountries = useMemo(() => getLocalStorage(LocalStorageKeys.countries) ?? [], [])

  // Update state with cached countries on initial render
  useLayoutEffect(() => {
    if (cachedCountries.length > 0) {
      setCountries(cachedCountries)
    }
  }, [cachedCountries])

  // Fetch countries if not already loaded and cache them
  useEffect(() => {
    fetchCountries().then()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const fetchCountries = async () => {
    if (countries.length === 0 && cachedCountries.length === 0) {
      try {
        const res = await mutateAsync()
        if (res.statusCode === STATUS.OK) {
          const countryData = res.data?.data ?? []
          if (countryData.length > 0) {
            setCountries(countryData)
            localStorage.setItem(LocalStorageKeys.countries, JSON.stringify(countryData))
          }
        }
      } catch (error) {
        // Handle error if needed
        console.error('Failed to fetch countries:', error)
      }
    }
  }

  return { countries, isCountryLoading: isPending }
}
